export const removeKeys = (groups) =>
  Object.values(groups).reduce((accum, val) => ({ ...accum, ...val }), {});
